import i18next from 'i18next';

export const approvalType = {
    FlAG: -1,
    BANK_ACCOUNT_CHANGE: 3,
    LEAVE: 4,
    VACATION: 5,
    SHIFT_EXCHANGE: 11,
    LEAVE_AZUR: 98,
    VACATION_AZUR: 99
};

export function getCentralApprovalTypeDescription(key) {
    switch (key) {
        case approvalType.BANK_ACCOUNT_CHANGE:
            return `${i18next.t('approvalCentral:requestType.bank-short')}`;
        case approvalType.LEAVE:
        case approvalType.LEAVE_AZUR:
            return `${i18next.t('approvalCentral:requestType.leave')}`;
        case approvalType.VACATION:
        case approvalType.VACATION_AZUR:
            return `${i18next.t('approvalCentral:requestType.vacation')}`;
        case approvalType.SHIFT_EXCHANGE:
            return `${i18next.t('approvalCentral:requestType.shift-short')}`;
        default:
            return ``;
    }
}

export function getCentralApprovalTypeColor(key) {
    switch (key) {
        case approvalType.BANK_ACCOUNT_CHANGE:
            return `#c36c6c`;
        case approvalType.LEAVE:
        case approvalType.LEAVE_AZUR:
            return `#97c36c`;
        case approvalType.VACATION:
        case approvalType.VACATION_AZUR:
            return `#6cc3c3`;
        case approvalType.SHIFT_EXCHANGE:
            return `#976cc3`;
        default:
            return `red`;
    }
}